export const initState = {
    app_data: {
        shop_plan: "",
        app_plan: "",
    },
    app_settings: {
        general_settings: {
            // active_theme: false,
            unlogged_user: true,
            show_number_status: true,
            app_script: false,
            app_wishlist_layout: "proxy",
            app_selector: false,
            preloader_icon: {
                icon_id: "icon-2",
                svg: `<path d="M10,40c0,0,0-0.4,0-1.1c0-0.3,0-0.8,0-1.3c0-0.3,0-0.5,0-0.8c0-0.3,0.1-0.6,0.1-0.9c0.1-0.6,0.1-1.4,0.2-2.1
                c0.2-0.8,0.3-1.6,0.5-2.5c0.2-0.9,0.6-1.8,0.8-2.8c0.3-1,0.8-1.9,1.2-3c0.5-1,1.1-2,1.7-3.1c0.7-1,1.4-2.1,2.2-3.1
                c1.6-2.1,3.7-3.9,6-5.6c2.3-1.7,5-3,7.9-4.1c0.7-0.2,1.5-0.4,2.2-0.7c0.7-0.3,1.5-0.3,2.3-0.5c0.8-0.2,1.5-0.3,2.3-0.4l1.2-0.1
                l0.6-0.1l0.3,0l0.1,0l0.1,0l0,0c0.1,0-0.1,0,0.1,0c1.5,0,2.9-0.1,4.5,0.2c0.8,0.1,1.6,0.1,2.4,0.3c0.8,0.2,1.5,0.3,2.3,0.5
                c3,0.8,5.9,2,8.5,3.6c2.6,1.6,4.9,3.4,6.8,5.4c1,1,1.8,2.1,2.7,3.1c0.8,1.1,1.5,2.1,2.1,3.2c0.6,1.1,1.2,2.1,1.6,3.1
                c0.4,1,0.9,2,1.2,3c0.3,1,0.6,1.9,0.8,2.7c0.2,0.9,0.3,1.6,0.5,2.4c0.1,0.4,0.1,0.7,0.2,1c0,0.3,0.1,0.6,0.1,0.9
                c0.1,0.6,0.1,1,0.1,1.4C74,39.6,74,40,74,40c0.2,2.2-1.5,4.1-3.7,4.3s-4.1-1.5-4.3-3.7c0-0.1,0-0.2,0-0.3l0-0.4c0,0,0-0.3,0-0.9
                c0-0.3,0-0.7,0-1.1c0-0.2,0-0.5,0-0.7c0-0.2-0.1-0.5-0.1-0.8c-0.1-0.6-0.1-1.2-0.2-1.9c-0.1-0.7-0.3-1.4-0.4-2.2
                c-0.2-0.8-0.5-1.6-0.7-2.4c-0.3-0.8-0.7-1.7-1.1-2.6c-0.5-0.9-0.9-1.8-1.5-2.7c-0.6-0.9-1.2-1.8-1.9-2.7c-1.4-1.8-3.2-3.4-5.2-4.9
                c-2-1.5-4.4-2.7-6.9-3.6c-0.6-0.2-1.3-0.4-1.9-0.6c-0.7-0.2-1.3-0.3-1.9-0.4c-1.2-0.3-2.8-0.4-4.2-0.5l-2,0c-0.7,0-1.4,0.1-2.1,0.1
                c-0.7,0.1-1.4,0.1-2,0.3c-0.7,0.1-1.3,0.3-2,0.4c-2.6,0.7-5.2,1.7-7.5,3.1c-2.2,1.4-4.3,2.9-6,4.7c-0.9,0.8-1.6,1.8-2.4,2.7
                c-0.7,0.9-1.3,1.9-1.9,2.8c-0.5,1-1,1.9-1.4,2.8c-0.4,0.9-0.8,1.8-1,2.6c-0.3,0.9-0.5,1.6-0.7,2.4c-0.2,0.7-0.3,1.4-0.4,2.1
                c-0.1,0.3-0.1,0.6-0.2,0.9c0,0.3-0.1,0.6-0.1,0.8c0,0.5-0.1,0.9-0.1,1.3C10,39.6,10,40,10,40z">
            
                <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 40 40" to="360 40 40" dur="0.6s" repeatCount="indefinite"></animateTransform>
            </path>`,
                width: 24,
                height: 24,
                view_box: "0 0 80 80",
                icon_color: "#43467F",
            },
            background_color: "#000000",
            text_color: "#ffffff",
            wishlist_page: "arena-wishlist-page",
            compare_page: "arena-compare-page",
            share_page: "arena-share-page",
            isActiveAT: false,
            text: {
                wishlist_settings: {
                    wishlist_page_title: "Wishlist Page",
                    wishlist_disable_msg: "Wishlist is disabled",
                    wishlist_empty_msg: "No products in wishlist!",
                    wishlist_login_msg:
                        'You have not logged in. Please <a title="Login url" href="/account/login">Login</a> to view wishlist content.',
                    table_product_heading: "Product Name",
                    table_image_heading: "Image",
                    table_quantity_heading: "Quantity",
                    table_variants_heading: "Variants",
                    table_price_heading: "Price",
                    table_delete_heading: "Delete",
                    table_available_heading: "Available",
                    table_add_to_cart_heading: "Add To Cart",
                    table_remove_heading: "Remove",
                    table_instock: "In stock",
                    table_outstock: "Out stock",
                    table_view_btn: "View Product",
                    notify_login: "Please login first to use wishlist function",
                    notify_limit: "Only {limit} products allowed to add to wishlist",
                    notify_getlist_error: "There is an error when getting wishlist",
                    wishlist_popup_add_button_text: "Add wishlist",
                    wishlist_popup_create_button_text: "Create new list",
                    wishlist_notify_added: "%product-name% \n Add to wishlist successfully",
                    wishlist_my_wishlist: "My wishlist",
                },
                compare_settings: {
                    compare_page_title: "Compare Page",
                    compare_disable_msg: "Compare is disabled",
                    compare_empty_msg: "No products in compare!",
                    table_feature_heading: "Features",
                    table_availability_heading: "Availability",
                    table_option_heading: "Options",
                    table_vendor_heading: "Vendor",
                    table_collection_heading: "Collection",
                    table_review_heading: "Rating",
                    table_instock: "In stock",
                    table_outstock: "Out stock",
                    table_view_btn: "View Product",
                    notify_limit: "Only {limit} products allowed to add to compare",
                    notify_modal_plugin:
                        "No modal plugin. Please embed Fancybox of Bootstrap modal to store",
                    notify_getlist_error: "There is an error when getting compare list",
                    notify_empty_product: "You have no products to compare",
                    compare_notify_create_custom:
                        "It will create a new compare list due to different product types with other products on compare list.",
                    compare_notify_added: "%product-name% \n Add to wishlist successfully",
                    compare_my_compare: "My compare",
                },
            },
        },
        wishlist_settings: {
            remove_add_to_cart: false,
            allow_multiple: false,
            add_multiple_settings: {
                add_background_color: "#dc3b1a",
                add_border_color: "#dc3b1a",
                add_text_color: "#fff",
                create_background_color: "#fff",
                create_border_color: "#dc3b1a",
                create_text_color: "#dc3b1a",
                radio_button_background_color: "#dc3b1a",
            },
            background_color: "#000000",
            text_color: "#ffffff",
            wishlist_enable: true,
            wishlist_product_number: 10,
            wishlist_layout: "page",
            redirect_wishlist: ["cart"],
            records_per_page: 5,
            wishlist_add_class: "add-to-wishlist",
            show_selector: {
                margin: "0",
                padding: "0",
                selector_class: "site-header__account",
                type: "Top",
            },
            page_show_mode: "both",
            add_selector: {
                margin: "0",
                padding: "0",
                selector_class: "product-form",
                type: "Top",
            },
            // wishlist_add_selector_class: "product-form",
            wishlist_show_class: "show-wishlist",
            // wishlist_show_selector_class: "site-header__account",
            wishlist_add_to_cart_class: "add-to-cart-wishlist",
            wishlist_remove_class: "remove-wishlist",
            wishlist_page_action: ["text"],
            wishlist_page_available: true,
            wishlist_options: ["price", "available", "quantity", "variants"],
            add_class_icon: {
                icon_id: "icon-1",
                svg: '<path d="M12.8194 22C12.5802 22 12.3665 21.9145 12.1785 21.7436L3.25614 13.1289L2.87156 12.7444C2.70063 12.5734 2.43569 12.2572 2.07675 11.7957C1.71781 11.3342 1.39305 10.8727 1.10247 10.4112C0.811898 9.94972 0.555509 9.37712 0.333306 8.69341C0.111102 8.00971 0 7.35164 0 6.71922C0 4.61683 0.606787 2.97594 1.82036 1.79655C3.03394 0.617164 4.70901 0.018924 6.84558 0.00183139C7.42673 0.00183139 8.02497 0.104384 8.64031 0.309495C9.25564 0.514607 9.82824 0.796636 10.3581 1.15558C10.888 1.51452 11.3495 1.83928 11.7426 2.12986C12.1357 2.42043 12.4947 2.74519 12.8194 3.10414C13.1613 2.76228 13.5202 2.43752 13.8963 2.12986C14.2723 1.82219 14.7338 1.49743 15.2808 1.15558C15.8277 0.813728 16.4003 0.531699 16.9986 0.309495C17.5968 0.0872916 18.1951 -0.0152612 18.7933 0.00183139C20.9299 0.00183139 22.605 0.600071 23.8185 1.79655C25.0321 2.99303 25.6389 4.6382 25.6389 6.73204C25.6389 8.82588 24.545 10.9667 22.3571 13.1546L13.4604 21.7436C13.2895 21.9145 13.0758 22 12.8194 22Z"/>',
                width: 18,
                height: 16,
                view_box: "0 0 26 22",
                icon_color: "#000000",
                icon_active_color: "#ff0000",
            },
            add_class_icon_product: {
                icon_id: "icon-1",
                svg: '<path d="M12.8194 22C12.5802 22 12.3665 21.9145 12.1785 21.7436L3.25614 13.1289L2.87156 12.7444C2.70063 12.5734 2.43569 12.2572 2.07675 11.7957C1.71781 11.3342 1.39305 10.8727 1.10247 10.4112C0.811898 9.94972 0.555509 9.37712 0.333306 8.69341C0.111102 8.00971 0 7.35164 0 6.71922C0 4.61683 0.606787 2.97594 1.82036 1.79655C3.03394 0.617164 4.70901 0.018924 6.84558 0.00183139C7.42673 0.00183139 8.02497 0.104384 8.64031 0.309495C9.25564 0.514607 9.82824 0.796636 10.3581 1.15558C10.888 1.51452 11.3495 1.83928 11.7426 2.12986C12.1357 2.42043 12.4947 2.74519 12.8194 3.10414C13.1613 2.76228 13.5202 2.43752 13.8963 2.12986C14.2723 1.82219 14.7338 1.49743 15.2808 1.15558C15.8277 0.813728 16.4003 0.531699 16.9986 0.309495C17.5968 0.0872916 18.1951 -0.0152612 18.7933 0.00183139C20.9299 0.00183139 22.605 0.600071 23.8185 1.79655C25.0321 2.99303 25.6389 4.6382 25.6389 6.73204C25.6389 8.82588 24.545 10.9667 22.3571 13.1546L13.4604 21.7436C13.2895 21.9145 13.0758 22 12.8194 22Z"/>',
                width: 18,
                height: 16,
                view_box: "0 0 26 22",
                icon_color: "#000000",
                icon_active_color: "#ff0000",
            },
            show_class_icon: {
                icon_id: "icon-1",
                svg: '<path d="M12.8194 22C12.5802 22 12.3665 21.9145 12.1785 21.7436L3.25614 13.1289L2.87156 12.7444C2.70063 12.5734 2.43569 12.2572 2.07675 11.7957C1.71781 11.3342 1.39305 10.8727 1.10247 10.4112C0.811898 9.94972 0.555509 9.37712 0.333306 8.69341C0.111102 8.00971 0 7.35164 0 6.71922C0 4.61683 0.606787 2.97594 1.82036 1.79655C3.03394 0.617164 4.70901 0.018924 6.84558 0.00183139C7.42673 0.00183139 8.02497 0.104384 8.64031 0.309495C9.25564 0.514607 9.82824 0.796636 10.3581 1.15558C10.888 1.51452 11.3495 1.83928 11.7426 2.12986C12.1357 2.42043 12.4947 2.74519 12.8194 3.10414C13.1613 2.76228 13.5202 2.43752 13.8963 2.12986C14.2723 1.82219 14.7338 1.49743 15.2808 1.15558C15.8277 0.813728 16.4003 0.531699 16.9986 0.309495C17.5968 0.0872916 18.1951 -0.0152612 18.7933 0.00183139C20.9299 0.00183139 22.605 0.600071 23.8185 1.79655C25.0321 2.99303 25.6389 4.6382 25.6389 6.73204C25.6389 8.82588 24.545 10.9667 22.3571 13.1546L13.4604 21.7436C13.2895 21.9145 13.0758 22 12.8194 22Z"/>',
                width: 18,
                height: 16,
                view_box: "0 0 26 22",
                icon_color: "#ffffff",
                icon_active_color: "#ff0000",
            },
            remove_class_icon: {
                icon_id: "icon-1",
                svg: `<path d="M294.111,256.001L504.109,46.003c10.523-10.524,10.523-27.586,0-38.109c-10.524-10.524-27.587-10.524-38.11,0L256,217.892
                L46.002,7.894c-10.524-10.524-27.586-10.524-38.109,0s-10.524,27.586,0,38.109l209.998,209.998L7.893,465.999
                c-10.524,10.524-10.524,27.586,0,38.109c10.524,10.524,27.586,10.523,38.109,0L256,294.11l209.997,209.998
                c10.524,10.524,27.587,10.523,38.11,0c10.523-10.524,10.523-27.586,0-38.109L294.111,256.001z" fill="#000000"></path>`,
                width: 16,
                height: 16,
                view_box: "0 0 512.001 512.001",
                icon_color: "#000000",
            },
            launch_show: {
                type: ["header"],
                placement: "Bottom Right",
                text: "My Wishlist",
                description: "",
                position_button: {
                    position: "absolute",
                    text_color: "#ffffff",
                    minWidth: "30px",
                    minHeight: "30px",
                    width: "150",
                    height: "45",
                    bottom: "20px",
                    right: "20px",
                    background_color: "#000000",
                    boxShadow: "rgb(153, 153, 153) 1px 1px 10px 0px",
                    borderRadius: "3",
                },
                showTittle: true,
                show: false,
                showBackground: true,
            },
            launch_add_product_page: {
                text: "Add To Wishlist",
                showTittle: true,
                showBackground: true,
                show: false,
                text_color: "#000000",
                background_color: "#EBC9C9",
                width: "50",
                height: "45",
                borderRadius: "3",
                showCount: false,
                check_add_variant: false,
                auto_insert_add_button: false,
                text_added: "Added To Wishlist",
                background_color_actived: "#EBC9C9",
                text_color_actived: "#000000",
            },
            launch_add: {
                text: "Add To Wishlist",
                showTittle: false,
                showBackground: false,
                show: false,
                text_color: "#000000",
                background_color: "#EBC9C9",
                width: "50",
                height: "45",
                borderRadius: "3",
                showCount: false,
                check_add_variant: false,
                auto_insert_add_button: false,
                text_added: "Added To Wishlist",
                background_color_actived: "#EBC9C9",
                text_color_actived: "#000000",
            },
            added_wl_notifications: "top-left",
            added_wl_notifications_bg: "#fff",
            added_wl_notifications_color: "#000",
            updated_at: 1603274589479,
            back_in_stock: false,
            reminder_mail: false,
            customCss: "",
        },
        compare_settings: {
            background_color: "#000000",
            text_color: "#ffffff",
            compare_enable: true,
            compare_product_number: 2,
            show_selector: {
                margin: "0",
                padding: "0",
                selector_class: "site-header__account",
                type: "Top",
            },
            add_selector: {
                margin: "0",
                padding: "0",
                selector_class: "product-form",
                type: "Top",
            },
            compare_add_class: "add-to-compare",
            compare_show_class: "show-compare",
            compare_show_selector_class: "site-header__account",
            comparet_add_selector_class: "product-form",
            compare_remove_class: "remove-compare",
            compare_options: ["vendor", "collection", "options", "availability"],
            custom_compare: false,
            compare_options2: [],
            compare_layout: ["page"],
            add_class_icon: {
                icon_id: "icon-1",
                svg: '<path d="M21.6334 13.2821C21.6334 13.3333 21.6334 13.3675 21.6334 13.3846C21.0175 15.9487 19.7344 18.0256 17.784 19.6154C15.8337 21.2051 13.5497 22 10.9322 22C9.54641 22 8.20341 21.735 6.90318 21.2051C5.60295 20.6752 4.43959 19.9231 3.4131 18.9487L1.56541 20.7949C1.37722 20.9829 1.16336 21.0769 0.923846 21.0769C0.68433 21.0769 0.470477 20.9829 0.282286 20.7949C0.0940954 20.6068 0 20.3932 0 20.1538V13.7436C0 13.5043 0.0940954 13.2906 0.282286 13.1026C0.470477 12.9145 0.68433 12.8205 0.923846 12.8205H7.33944C7.57896 12.8205 7.79281 12.9145 7.981 13.1026C8.16919 13.2906 8.25474 13.5043 8.23763 13.7436C8.22052 13.9829 8.13498 14.1966 7.981 14.3846L6.005 16.359C6.68933 16.9744 7.4592 17.4615 8.31462 17.8205C9.17003 18.1795 10.0682 18.3504 11.0092 18.3333C12.2752 18.3333 13.4642 18.0171 14.5762 17.3846C15.6883 16.7521 16.5779 15.906 17.2451 14.8462C17.3478 14.6752 17.6044 14.1111 18.015 13.1538C18.0834 12.9316 18.2203 12.8205 18.4256 12.8205H21.1715C21.3083 12.8205 21.4195 12.8718 21.5051 12.9744C21.5906 13.0769 21.6334 13.1795 21.6334 13.2821ZM21.9927 1.84615V8.25641C21.9927 8.49573 21.9071 8.7094 21.736 8.89744C21.565 9.08547 21.3426 9.17949 21.0688 9.17949H14.6532C14.4137 9.17949 14.1999 9.08547 14.0117 8.89744C13.8235 8.7094 13.7379 8.49573 13.755 8.25641C13.7721 8.01709 13.8577 7.80342 14.0117 7.61538L15.9877 5.64103C14.5848 4.32479 12.9253 3.66667 11.0092 3.66667C9.72605 3.66667 8.52847 3.98291 7.41643 4.61539C6.30439 5.24786 5.41476 6.09402 4.74754 7.15385C4.64489 7.32479 4.39682 7.88889 4.00333 8.84616C3.91779 9.06838 3.77237 9.17949 3.56707 9.17949H0.718547C0.598789 9.17949 0.487585 9.12821 0.384936 9.02564C0.282286 8.92308 0.239516 8.82051 0.256624 8.71795V8.61539C0.872521 6.05128 2.16419 3.97436 4.13164 2.38462C6.09909 0.794873 8.3916 0 11.0092 0C12.3949 0 13.7465 0.264958 15.0638 0.794872C16.3812 1.32479 17.5531 2.07692 18.5796 3.05128L20.4273 1.20513C20.6155 1.01709 20.8293 0.923078 21.0688 0.923078C21.3083 0.923078 21.5307 1.01709 21.736 1.20513C21.9413 1.39316 22.0269 1.60684 21.9927 1.84615Z"/>',
                width: 22,
                height: 16,
                view_box: "0 0 22 22",
                icon_color: "#000000",
                icon_active_color: "#ff0000",
            },
            add_class_icon_product: {
                icon_id: "icon-1",
                svg: '<path d="M21.6334 13.2821C21.6334 13.3333 21.6334 13.3675 21.6334 13.3846C21.0175 15.9487 19.7344 18.0256 17.784 19.6154C15.8337 21.2051 13.5497 22 10.9322 22C9.54641 22 8.20341 21.735 6.90318 21.2051C5.60295 20.6752 4.43959 19.9231 3.4131 18.9487L1.56541 20.7949C1.37722 20.9829 1.16336 21.0769 0.923846 21.0769C0.68433 21.0769 0.470477 20.9829 0.282286 20.7949C0.0940954 20.6068 0 20.3932 0 20.1538V13.7436C0 13.5043 0.0940954 13.2906 0.282286 13.1026C0.470477 12.9145 0.68433 12.8205 0.923846 12.8205H7.33944C7.57896 12.8205 7.79281 12.9145 7.981 13.1026C8.16919 13.2906 8.25474 13.5043 8.23763 13.7436C8.22052 13.9829 8.13498 14.1966 7.981 14.3846L6.005 16.359C6.68933 16.9744 7.4592 17.4615 8.31462 17.8205C9.17003 18.1795 10.0682 18.3504 11.0092 18.3333C12.2752 18.3333 13.4642 18.0171 14.5762 17.3846C15.6883 16.7521 16.5779 15.906 17.2451 14.8462C17.3478 14.6752 17.6044 14.1111 18.015 13.1538C18.0834 12.9316 18.2203 12.8205 18.4256 12.8205H21.1715C21.3083 12.8205 21.4195 12.8718 21.5051 12.9744C21.5906 13.0769 21.6334 13.1795 21.6334 13.2821ZM21.9927 1.84615V8.25641C21.9927 8.49573 21.9071 8.7094 21.736 8.89744C21.565 9.08547 21.3426 9.17949 21.0688 9.17949H14.6532C14.4137 9.17949 14.1999 9.08547 14.0117 8.89744C13.8235 8.7094 13.7379 8.49573 13.755 8.25641C13.7721 8.01709 13.8577 7.80342 14.0117 7.61538L15.9877 5.64103C14.5848 4.32479 12.9253 3.66667 11.0092 3.66667C9.72605 3.66667 8.52847 3.98291 7.41643 4.61539C6.30439 5.24786 5.41476 6.09402 4.74754 7.15385C4.64489 7.32479 4.39682 7.88889 4.00333 8.84616C3.91779 9.06838 3.77237 9.17949 3.56707 9.17949H0.718547C0.598789 9.17949 0.487585 9.12821 0.384936 9.02564C0.282286 8.92308 0.239516 8.82051 0.256624 8.71795V8.61539C0.872521 6.05128 2.16419 3.97436 4.13164 2.38462C6.09909 0.794873 8.3916 0 11.0092 0C12.3949 0 13.7465 0.264958 15.0638 0.794872C16.3812 1.32479 17.5531 2.07692 18.5796 3.05128L20.4273 1.20513C20.6155 1.01709 20.8293 0.923078 21.0688 0.923078C21.3083 0.923078 21.5307 1.01709 21.736 1.20513C21.9413 1.39316 22.0269 1.60684 21.9927 1.84615Z"/>',
                width: 22,
                height: 16,
                view_box: "0 0 22 22",
                icon_color: "#000000",
                icon_active_color: "#ff0000",
            },
            show_class_icon: {
                icon_id: "icon-1",
                svg: '<path d="M21.6334 13.2821C21.6334 13.3333 21.6334 13.3675 21.6334 13.3846C21.0175 15.9487 19.7344 18.0256 17.784 19.6154C15.8337 21.2051 13.5497 22 10.9322 22C9.54641 22 8.20341 21.735 6.90318 21.2051C5.60295 20.6752 4.43959 19.9231 3.4131 18.9487L1.56541 20.7949C1.37722 20.9829 1.16336 21.0769 0.923846 21.0769C0.68433 21.0769 0.470477 20.9829 0.282286 20.7949C0.0940954 20.6068 0 20.3932 0 20.1538V13.7436C0 13.5043 0.0940954 13.2906 0.282286 13.1026C0.470477 12.9145 0.68433 12.8205 0.923846 12.8205H7.33944C7.57896 12.8205 7.79281 12.9145 7.981 13.1026C8.16919 13.2906 8.25474 13.5043 8.23763 13.7436C8.22052 13.9829 8.13498 14.1966 7.981 14.3846L6.005 16.359C6.68933 16.9744 7.4592 17.4615 8.31462 17.8205C9.17003 18.1795 10.0682 18.3504 11.0092 18.3333C12.2752 18.3333 13.4642 18.0171 14.5762 17.3846C15.6883 16.7521 16.5779 15.906 17.2451 14.8462C17.3478 14.6752 17.6044 14.1111 18.015 13.1538C18.0834 12.9316 18.2203 12.8205 18.4256 12.8205H21.1715C21.3083 12.8205 21.4195 12.8718 21.5051 12.9744C21.5906 13.0769 21.6334 13.1795 21.6334 13.2821ZM21.9927 1.84615V8.25641C21.9927 8.49573 21.9071 8.7094 21.736 8.89744C21.565 9.08547 21.3426 9.17949 21.0688 9.17949H14.6532C14.4137 9.17949 14.1999 9.08547 14.0117 8.89744C13.8235 8.7094 13.7379 8.49573 13.755 8.25641C13.7721 8.01709 13.8577 7.80342 14.0117 7.61538L15.9877 5.64103C14.5848 4.32479 12.9253 3.66667 11.0092 3.66667C9.72605 3.66667 8.52847 3.98291 7.41643 4.61539C6.30439 5.24786 5.41476 6.09402 4.74754 7.15385C4.64489 7.32479 4.39682 7.88889 4.00333 8.84616C3.91779 9.06838 3.77237 9.17949 3.56707 9.17949H0.718547C0.598789 9.17949 0.487585 9.12821 0.384936 9.02564C0.282286 8.92308 0.239516 8.82051 0.256624 8.71795V8.61539C0.872521 6.05128 2.16419 3.97436 4.13164 2.38462C6.09909 0.794873 8.3916 0 11.0092 0C12.3949 0 13.7465 0.264958 15.0638 0.794872C16.3812 1.32479 17.5531 2.07692 18.5796 3.05128L20.4273 1.20513C20.6155 1.01709 20.8293 0.923078 21.0688 0.923078C21.3083 0.923078 21.5307 1.01709 21.736 1.20513C21.9413 1.39316 22.0269 1.60684 21.9927 1.84615Z"/>',
                width: 18,
                height: 16,
                view_box: "0 0 26 22",
                icon_color: "#ffffff",
                icon_active_color: "#ff0000",
            },
            remove_class_icon: {
                icon_id: "icon-1",
                svg: `<path d="M294.111,256.001L504.109,46.003c10.523-10.524,10.523-27.586,0-38.109c-10.524-10.524-27.587-10.524-38.11,0L256,217.892
                L46.002,7.894c-10.524-10.524-27.586-10.524-38.109,0s-10.524,27.586,0,38.109l209.998,209.998L7.893,465.999
                c-10.524,10.524-10.524,27.586,0,38.109c10.524,10.524,27.586,10.523,38.109,0L256,294.11l209.997,209.998
                c10.524,10.524,27.587,10.523,38.11,0c10.523-10.524,10.523-27.586,0-38.109L294.111,256.001z" fill="#000000"></path>`,
                width: 16,
                height: 16,
                view_box: "0 0 512.001 512.001",
                icon_color: "#000000",
            },
            launch_show: {
                type: ["header"],
                placement: "Bottom Right",
                text: "My Compare",
                description: "",
                position_button: {
                    position: "absolute",
                    text_color: "#ffffff",
                    minWidth: "30px",
                    minHeight: "30px",
                    width: "160",
                    height: "45",
                    bottom: "20px",
                    right: "20px",
                    background_color: "#000000",
                    boxShadow: "rgb(153, 153, 153) 1px 1px 10px 0px",
                    borderRadius: "3",
                },
                showTittle: true,
                show: false,
                showBackground: true,
            },
            launch_add: {
                text: "Add to Compare",
                showTittle: false,
                showBackground: false,
                show: false,
                text_color: "#000000",
                background_color: "#EBC9C9",
                width: "50",
                height: "45",
                borderRadius: "3",
                auto_insert_add_button: false,
                text_added: "Added To Compare",
                background_color_actived: "#EBC9C9",
                text_color_actived: "#000000",
            },
            launch_add_product_page: {
                text: "Add to Compare",
                showTittle: true,
                showBackground: true,
                show: false,
                text_color: "#000000",
                background_color: "#EBC9C9",
                width: "50",
                height: "45",
                borderRadius: "3",
                auto_insert_add_button: false,
                text_added: "Added To Compare",
                background_color_actived: "#EBC9C9",
                text_color_actived: "#000000",
            },
            updated_at: 1603274589479,
            added_cp_notifications: "top-left",
            added_cp_notifications_bg: "#fff",
            added_cp_notifications_color: "#000",
        },
    },

    parent_pages: {
        data: [
            {
                id: "Wishlist - Compare",
                content: "Wishlist - Compare",
                accessibilityLabel: "Wishlist - Compare",
                panelID: "Wishlist - Compare",
            },
            {
                id: "Pre-order",
                content: "Pre-order",
                accessibilityLabel: "Pre-order",
                panelID: "Pre-order",
            },
            {
                id: "Contact",
                content: "Contact",
                accessibilityLabel: "Contact",
                panelID: "Contact",
            },
            {
                id: "Notifications",
                content: "Notifications",
                accessibilityLabel: "Notifications",
                panelID: "Notifications",
            },
            {
                id: "Plan",
                content: "Plan",
                accessibilityLabel: "Plan",
                panelID: "Plan",
            },
            {
                id: "Support",
                content: "Support",
                accessibilityLabel: "Support",
                panelID: "Support",
            },
        ],
        selected: 0,
    },

    pre_order_pages: {
        data: [
            {
                id: "Single Product",
                content: "Single Product",
                accessibilityLabel: "Single Product",
                panelID: "Single Product",
            },
            // {
            //     id: "MultiProduct",
            //     content: "MultiProduct",
            //     accessibilityLabel: "MultiProduct",
            //     panelID: "MultiProduct",
            // },
            {
                id: "Order",
                content: "Order",
                accessibilityLabel: "Order",
                panelID: "Order",
            },
            // {
            //     id: "Settings",
            //     content: "Settings",
            //     accessibilityLabel: "Settings",
            //     panelID: "Settings",
            // },
            // {
            //     id: "Theme Setup",
            //     content: "Theme Setup",
            //     accessibilityLabel: "Theme Setup",
            //     panelID: "Theme Setup",
            // },
        ],
        selected: 0,
    },

    pages: {
        data: [
            {
                id: "General",
                content: "General",
                accessibilityLabel: "General",
                panelID: "General",
            },
            {
                id: "Wishlist",
                content: "Wishlist",
                accessibilityLabel: "Wishlist",
                panelID: "Wishlist",
            },
            {
                id: "Compare",
                content: "Compare",
                accessibilityLabel: "Compare",
                panelID: "Compare",
            },
            {
                id: "Back in stock",
                content: "Back in stock",
                accessibilityLabel: "Back in stock",
                panelID: "Back in stock",
            },
            {
                id: "ReminderEmail",
                content: "Reminder Email",
                accessibilityLabel: "Reminder Email",
                panelID: "ReminderEmail",
            },
            {
                id: "Statistics",
                content: "Statistics",
                accessibilityLabel: "Statistics",
                panelID: "Statistics",
            },
            {
                id: "Translation",
                content: "Translation",
                accessibilityLabel: "Translation",
                panelID: "Translation",
            },
            {
                id: "Theme integration",
                content: "Theme integration",
                accessibilityLabel: "Theme integration",
                panelID: "Theme integration",
            },
        ],
        selected: 0,
    },
    widgets: [
        [
            {
                id: 0,
                code: `{% render 'arn_wl_cp_buttons', type: 'wl_show_btn', product_handle: product.handle %}`,
                updated_at: 1603274589479,
                enabled: true,
                name: "Show Wishlist Button",
                saveState: false,
            },
            {
                id: 1,
                code: `{% if shop.metafields.arena.wl_cp_settings.wishlist_settings.launch_add.check_add_variant == true or shop.metafields.arena.wl_cp_settings.value.wishlist_settings.launch_add.check_add_variant == true %}
                  {% render 'arn_wl_cp_buttons', type: 'wl_add_btn', product_handle: product.selected_or_first_available_variant.id %}
                    {% else %}
                {% render 'arn_wl_cp_buttons', type: 'wl_add_btn', product_handle: product.handle %}
                 {% endif %}
      `,
                updated_at: 1603274589479,
                enabled: true,
                name: "Add to Wishlist Button",
                saveState: false,
            },
            {
                id: 2,
                code: `{% render 'arn_wl_cp_buttons', type: 'wl_remove-btn', product_handle: product.handle %}`,
                updated_at: 1603274589479,
                enabled: true,
                name: "Remove Wishlist Button",
                saveState: false,
            },
        ],
        [
            {
                id: 0,
                code: `{% render 'arn_wl_cp_buttons', type: 'cp_show_btn', product_handle: product.handle %}`,
                updated_at: 1603274589479,
                enabled: true,
                name: "Show Compare Button",
                saveState: false,
            },
            {
                id: 1,
                code: `{% render 'arn_wl_cp_buttons', type: 'cp_add_btn', product_handle: product.handle %}`,
                updated_at: 1603274589479,
                enabled: true,
                name: "Add to Compare Button",
                saveState: false,
            },
            {
                id: 2,
                code: `{% render 'arn_wl_cp_buttons', type: 'cp_remove_btn', product_handle: product.handle %}`,
                updated_at: 1603274589479,
                enabled: true,
                name: "Remove Compare Button",
                saveState: false,
            },
        ],
        [
            {
                id: 0,
                updated_at: 1603274589479,
                enabled: true,
                name: "Configure back in stock alert",
                saveState: false,
            },
        ],
        [
            {
                id: 0,
                updated_at: 1603274589479,
                enabled: true,
                name: "Configure reminder email",
                saveState: false,
            },
        ],
    ],
    widget_selected: {},
    app_edited: {
        wishlist_settings_edited: [],
        compare_settings_edited: [],
        general_settings_edited: [],
    },
    pages_config: "WidgetsManagement",
    plan: { current_plan: "free" },
    app_render: {},
    layout_reminder_mail: {
        subject: "Your Wishlist on {{{shop}}}",
        time: "10",
        textEditor: {
            blocks: [
                {
                    key: "evr7p",
                    text: "Hi, We noticed that you've checked these items out and saved them to your Wishlist. For the best experience, we will keep them here while you sleep on it!",
                    type: "unstyled",
                    depth: 0,
                    inlineStyleRanges: [],
                    entityRanges: [],
                    data: { "text-align": "center" },
                },
            ],
            entityMap: {},
        },
    },
    layout_mail: {
        text: "",
        button: {
            text: "Buy Now",
            borderRadius: "3",
            fontSize: "16",
            padding: "10",
            color: "#ffffff",
            backgroundColor: "#2baadf",
            subject: "{{Title}} is back in stock",
        },
        textEditor: {
            blocks: [
                {
                    key: "evr7p",
                    text: "Great news!",
                    type: "unstyled",
                    depth: 0,
                    inlineStyleRanges: [
                        { offset: 0, length: 11, style: "fontsize-18" },
                        { offset: 0, length: 11, style: "color-rgb(0,0,0)" },
                    ],
                    entityRanges: [],
                    data: { "text-align": "center" },
                },
                {
                    key: "6p9r0",
                    text: "{{Title}} is back in stock",
                    type: "unstyled",
                    depth: 0,
                    inlineStyleRanges: [{ offset: 0, length: 26, style: "fontsize-18" }],
                    entityRanges: [],
                    data: {},
                },
            ],
            entityMap: {},
        },
    },
    compare_custom: {
        attribute_compare: [],
        compare_options: [],
        isInstall: false,
        isInstallAT: false,
    },
}
